import { IconColor } from './iconsInterface'

export default function DownloadIcon({ color }: IconColor): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200">
      <path
        d="M1152.84 366.46c-30.21-71.45-73.48-135.63-128.58-190.71C969.17 120.65 905 77.38 833.55 47.17 759.57 15.86 680.98 0 600 0S440.42 15.86 366.46 47.16c-71.45 30.21-135.63 73.48-190.71 128.58C120.65 230.83 77.38 295 47.17 366.45 15.86 440.43 0 519.02 0 600s15.86 159.58 47.16 233.54c30.21 71.45 73.48 135.63 128.58 190.71 55.09 55.1 119.26 98.37 190.71 128.58 73.98 31.3 152.56 47.16 233.54 47.16s159.58-15.86 233.54-47.16c71.45-30.21 135.63-73.48 190.71-128.58 55.1-55.09 98.37-119.26 128.58-190.71 31.3-73.98 47.16-152.56 47.16-233.54s-15.86-159.58-47.16-233.54zM861.59 937.84H338.42v-73.51h523.16v73.51zM754.25 555.68l51.99 51.99-206.23 206.22-206.23-206.22 51.99-51.99 117.49 117.49V298.93h73.51v374.24l117.49-117.49z"
        fill={color}
      />
    </svg>
  )
}
